import { format, toZonedTime } from '@blockworks/platform/libs/date-fns';

export function formatUnixTimestampToTime(unixTimestamp: number, timezone: string = 'America/Denver'): string {
    const date = new Date(unixTimestamp * 1000);
    const zonedDate = toZonedTime(date, timezone);

    return format(zonedDate, 'h:mm a');
}
